// Series tokens for add-on charts/sparklines (astral = metric, azure = dynos).
// Map to theme CSS variables (--color-astral-*, --color-azure-*).

export const SERIES = {
  astral: {
    stroke: "var(--color-astral-500)",
    band: "color-mix(in srgb, var(--color-astral-500) 12%, transparent)",
  },
  azure: {
    stroke: "var(--color-azure-500)",
    band: "color-mix(in srgb, var(--color-azure-500) 12%, transparent)",
  },
}

export function seriesPalette(name) {
  return SERIES[name] ?? SERIES.astral
}

// Threshold / ratio guide lines on metric charts and sparklines (azure-500 at 50%/60%).
export function referenceStroke(dark) {
  return dark
    ? "color-mix(in srgb, var(--color-azure-500) 50%, transparent)"
    : "color-mix(in srgb, var(--color-azure-500) 60%, transparent)"
}
